<ng-container [caLocalizationScope]="localizationScope">
  <i
    class="f-i f-i-crm text-muted"
    [ngClass]="[iconClass, iconSizeClass]"
    [ngbTooltip]="tooltipContent"
    [container]="container"
    data-automation-id="crm-icon"
  >
  </i>
  <ng-template #tooltipContent>
    <span>{{ 'crmIconTitle' | caLocalize }}</span>
  </ng-template>
</ng-container>
